import { render } from "./UseCase.vue?vue&type=template&id=b858a046"
import script from "./UseCase.vue?vue&type=script&lang=js"
export * from "./UseCase.vue?vue&type=script&lang=js"

import "./UseCase.vue?vue&type=style&index=0&id=b858a046&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__